import * as React from 'react';

import cx from 'classnames';
import { CtaBookNow } from 'themes/playful/components/CtaBookNow/CtaBookNow';
import { Title } from 'themes/playful/components/Title/Title';

import {
  ContactFormState,
  useContactPage,
} from 'hooks/page/contact/useContactPage';

import s from './PlayfulContact.module.css';
import s1 from 'themes/playful/components/PlayfulLayout.module.css';

export const PlayfulContact = () => {
  const { formState, onSubmit, renderFormElements } = useContactPage({
    styles: {
      input: s.formInput,
      textarea: s.formTextArea,
      button: s.sendButton,
      error: s.error,
      subtitle: s.formSubTitle,
      recaptchaDisclaimer: s.recaptchaDisclaimer,
    },
  });

  const ContactFormSent = () => <p>Your message has been sent!</p>;

  const ContactFormError = () => (
    <p>Error sending your message. Please try again later.</p>
  );

  const renderContent = () => {
    switch (formState) {
      case ContactFormState.SENT:
        return <ContactFormSent />;
      case ContactFormState.ERROR:
        return <ContactFormError />;
      default:
        return <form onSubmit={onSubmit}>{renderFormElements()}</form>;
    }
  };

  const renderTitle = () => {
    if (formState === ContactFormState.DEFAULT) {
      return <Title className={s.title}>Contact us</Title>;
    }

    return null;
  };

  return (
    <>
      <div className={cx(s.root, s1.content)}>
        {renderTitle()}
        <div className={s.wrapper}>{renderContent()}</div>
      </div>
      <CtaBookNow />
    </>
  );
};
